export default "__VITE_ASSET__d0d67bf0__"